import { CollectionItem } from "@features/pages/collection/interface/collection-iterface";

export type ConnectionState = 'connected' | 'disconnected' | 'reconnecting';

// App-wide room namespaces
export type RoomNamespace =
    | 'user'
    | 'chat'
    | 'dashboard'
    | 'notification'
    | 'project'
    | 'admin';

// ---------------- SERVER → CLIENT ----------------
export interface ServerToClientEvents {
    'image:queued': CollectionItem;
    'image:generated': CollectionItem;
    'image:error': { message: string; details?: any };
}

// ---------------- ROOM EVENTS ----------------
export type RoomEvents = {
    [R in RoomNamespace as `${R}:join`]: (payload: { roomId: string }) => void;
} & {
    [R in RoomNamespace as `${R}:leave`]: (payload: { roomId: string }) => void;
};

// ---------------- CLIENT → SERVER ----------------
export interface ClientToServerEvents extends RoomEvents {
    sendMessage: (
        payload: { text: string; roomId: string },
        ack: (res: { success: boolean }) => void
    ) => void;
}


export const RoomId = {
    user: (id: string) => `user:${id}`,
    chat: (id: string) => `chat:${id}`,
    dashboard: (id: string) => `dashboard:${id}`,
    notification: (id: string) => `notification:${id}`,
    project: (id: string) => `project:${id}`,
    admin: (id: string) => `admin:${id}`,
};